import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { ButtonProps } from 'shared/mui/Buttons';

import { FilterApplyButtonStyled } from './FilterApplyButton.styled';

export type FilterApplyButtonProps = ButtonProps;

export const FilterApplyButton: React.FC<FilterApplyButtonProps> = ({
  label,
  color = 'primary',
  variant = 'contained',
  disabled,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const {
    formState: { isDirty, dirtyFields },
  } = useFormContext();
  const { filterValues = {} } = useListContext();

  const isEmptyUrlFilters = Object.keys(filterValues).length === 0;
  const computedDisabled = isEmptyUrlFilters && (!isDirty || Object.keys(dirtyFields).length === 0);

  return (
    <FilterApplyButtonStyled
      color={color}
      disabled={disabled ?? computedDisabled}
      label={label || translate('app.buttons.apply')}
      variant={variant}
      {...restProps}
    />
  );
};
